import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { Typography } from "antd";
import { useLocation } from "react-router-dom";
import { useAuth } from '../contexts/authContext';
import {setUserId, trackPageView} from "../config/amplitude/amplitude";

const { Title } = Typography;

const OnboardingPage = () => {
    const { currentUser } = useAuth();
    const [highlightVideo2, setHighlightVideo2] = useState(false);
    const location = useLocation();

    // Ref for the second video
    const video2Ref = useRef(null);

    useEffect(() => {

        document.title = 'Onboarding - CV Postman App';
        localStorage.setItem('lastOpenedPage', '/onboarding');
        setUserId(currentUser.email);
        const params = new URLSearchParams(location.search);
        if (params.get("highlight") === "video2") {
            setHighlightVideo2(true);
            // Scroll to the second video after the component is mounted
            setTimeout(() => {
                video2Ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 100); // Delay to ensure the component is fully rendered
        }
    }, [location]);

    return (
        <div style={{maxWidth: 600, margin: "auto", padding: "20px"}}>
            <Title level={3}>Onboarding</Title>

            <div style={{marginBottom: "20px"}}>
                <ReactPlayer url="https://youtu.be/0NBxrRtu0Lk" width="100%" controls/>
            </div>

            <div
                ref={video2Ref}
                style={{marginBottom: "20px", border: highlightVideo2 ? "2px solid #1890ff" : "none"}}
            >
                <ReactPlayer url="https://youtu.be/hNYPH8Ho8Kk" width="100%" controls/>
            </div>

        </div>
    );
};

export default OnboardingPage;
